"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../button");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _utils = require("../../utils");

var _RotatingContainer = _interopRequireDefault(require("../RotatingContainer"));

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var _excluded = ["id", "children", "getTriggerProps", "isOpen", "shouldUseStencilButton", "disabled", "error", "warning"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DropdownTriggerComponent = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, externalRef) {
  var id = _ref.id,
      children = _ref.children,
      getTriggerProps = _ref.getTriggerProps,
      isOpen = _ref.isOpen,
      shouldUseStencilButton = _ref.shouldUseStencilButton,
      disabled = _ref.disabled,
      error = _ref.error,
      warning = _ref.warning,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var chevronColor = disabled ? _constants.CHEVRON_COLOR_DISABLED : _constants.CHEVRON_COLOR; // Splitting props to override only ones with aria-* prop

  var _useMemo = (0, _react.useMemo)(function () {
    return Object.entries(forwardedProps).reduce(function (acc, _ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      var parentKey = key.includes('aria-') ? acc.ariaProps : acc.restProps;

      if (value !== undefined) {
        parentKey[key] = value;
      }

      return acc;
    }, {
      ariaProps: {},
      restProps: {}
    });
  }, [forwardedProps]),
      ariaProps = _useMemo.ariaProps,
      restProps = _useMemo.restProps;

  var hasAriaDisabled = !!ariaProps['aria-disabled']; // Provide only defined id as downshift generate by itself
  // if it's not provided at all

  var definedIdProp = id !== undefined ? {
    id: id
  } : {};
  var TriggerButton = shouldUseStencilButton ? _button.Button : _helperComponents.DropdownTriggerStyledButton;
  return (0, _core.jsx)(TriggerButton, (0, _extends2.default)({
    hasAriaDisabled: hasAriaDisabled,
    disabled: disabled,
    error: error,
    warning: warning,
    isOpen: isOpen
  }, restProps, getTriggerProps(_objectSpread(_objectSpread({
    ref: externalRef
  }, definedIdProp), ariaProps), {
    suppressRefError: true
  }), {
    type: "button"
  }), (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    justifyContent: "space-between",
    gridGap: _constants.TRIGGER_HORIZONTAL_GAP
  }, (0, _core.jsx)(_helperComponents.StartAlignedRow, {
    gridGap: _constants.TRIGGER_HORIZONTAL_GAP
  }, (!!disabled || hasAriaDisabled) && (0, _core.jsx)(_icons.IconDisabled, {
    color: _constants.TEXT_COLOR_DISABLED,
    "aria-hidden": true
  }), children), !hasAriaDisabled && (0, _core.jsx)(_RotatingContainer.default, {
    isRotated: !!isOpen
  }, (0, _core.jsx)(_icons.IconChevronDown, {
    color: chevronColor,
    "aria-hidden": true
  }))));
});
DropdownTriggerComponent.displayName = 'DropdownTrigger';
var DropdownTrigger = (0, _utils.withTestAttributes)({
  component: 'StencilSelectTrigger'
})(DropdownTriggerComponent);
var _default = DropdownTrigger;
exports.default = _default;